import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate"; // Store Custom Code
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered"; // Store Custom Code - Remove Imports
import { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import PlusCircle from "@insite/mobius/Icons/PlusCircle"; // Store Custom Code
import { SelectPresentationProps } from "@insite/mobius/Select"; // Store Custom Code
import { TextFieldProps } from "@insite/mobius/TextField"; // Store Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import OutOfMarketNoticeMailComponent, {
    OutOfMarketNoticeMailComponentStyles,
} from "@store/Components/Market/OutOfMarketNoticeMailComponent";
import ProductAddToCartButton from "@store/Overrides/Components/ProductAddToCartButton";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
// Store Custom Code - Remove Imports
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@store/Overrides/Components/ProductQuantityBreakPricing"; // Store Custom Code - Use Custom imports instead
import { COLORS, SPACING, TYPOGRAPHY } from "@store/theme/design"; // Store Custom Code
import { buttonBaseStyles } from "@store/theme/mixins";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

// Store Custom Code
const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
    promotionCategories = "Promotions",
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    actionSection?: GridContainerProps; // Store Custom Code
    productPriceGrid?: GridItemProps; // Store Custom Code
    productPriceBreakGrid?: GridItemProps; // Store Custom Code
    productInfoGrid?: GridItemProps; // Store Custom Code
    marketWarningStyles?: OutOfMarketNoticeMailComponentStyles; // Store Custom Code
}

export const actionsStyles: ProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
            padding: 0 ${SPACING.standard}; // Store Custom Code
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 20px;
            `,
        },
    },
    // Store Custom Code: Remove quantityBreakPricing
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            width: 100%; // Store Custom Code
        `,
    },
    addToCartButton: {
        css: css`
            padding: 0; // Store Custom Code
            height: 50px; // Store Custom Code
            width: 100%; // Store Custom Code
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 3.1rem; // Store Custom Code
                min-width: 3.1rem; // Store Custom Code
                // Store Custom Code
                input {
                    text-align: center;
                    padding: 0 9px !important;
                }
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 20px;
            min-height: 2rem;
            text-align: right; // Store Custom Code
        `,
    },
    // Store Custom Code
    actionSection: {
        css: css`
            border-top: 1px solid ${COLORS.border.base};
            border-bottom: 1px solid ${COLORS.border.base};
            padding: ${SPACING.small} 0;
        `,
    },
    // Store Custom Code
    productPriceGrid: {
        width: 4,
        css: css`
            align-items: center;
            font-weight: ${TYPOGRAPHY.weight.black};
        `,
    },
    // Store Custom Code
    productPriceBreakGrid: {
        width: 12,
        css: css`
            padding-top: 12px;
            padding-right: 0px;
            padding-bottom: 0px;
            padding-left: 15px;
        `,
    },
    // Store Custom Code
    addToListLink: {
        link: {
            icon: {
                iconProps: {
                    src: PlusCircle,
                    css: css`
                        svg {
                            fill: #000;
                            stroke: white;
                        }
                    `,
                },
                position: "left",
            },
            typographyProps: {
                css: css`
                    text-align: left;
                    color: #000;
                    font-weight: bold;
                    margin-left: 3px;
                `,
            },
            hoverMode: "lighten",
        },
    },
    // Store Custom Code
    productInfoGrid: {
        width: 8,
    },
    // Store Custom Code
    price: {
        savingsMessageText: {
            size: TYPOGRAPHY.size.base,
            css: css`
                font-weight: normal;
                text-decoration: line-through;
            `,
        },
        priceDiscounted: {
            priceText: {
                weight: TYPOGRAPHY.weight.bold,
                size: TYPOGRAPHY.size.base,
            },
        },
    },
    // Store Custom Code
    marketWarningStyles: {
        wrapper: {
            css: css`
                width: 100%;
                align-self: end;
            `,
        },
        messageText: {
            size: TYPOGRAPHY.size.tiny,
        },
        submitButton: {
            variant: "secondary",
            css: css`
                ${buttonBaseStyles("solid")}
                width: 100%;
                padding-left: ${TYPOGRAPHY.spacing.base};
                padding-right: ${TYPOGRAPHY.spacing.base};
            `,
        },
    },
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({ productContext, productSettings, showPrice, showAddToList }) => {
    /* Store Custom Code - Start */
    const [analyticsListName, setAnalyticsListName] = React.useState<string | null>(null);
    React.useEffect(() => {
        const path = window.location.pathname.toLowerCase();
        if (path === "/search") {
            setAnalyticsListName(pageType.searchPage);
        }
        if (path.includes("catalog/products/promotions")) {
            setAnalyticsListName(pageType.promotionCategories);
        }
    }, []);
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Store Custom Code */}
            {productSettings.canSeePrices && (
                <GridContainer {...styles.actionSection}>
                    <GridItem {...styles.productPriceBreakGrid}>
                        {/* Store Custom Code */}
                        <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} isModal={true} />
                    </GridItem>

                    <GridItem {...styles.productPriceGrid}>
                        {showPrice && (
                            <>
                                {/* Store Custom Code: usePriceMinusCorePrice, showEcoLabel */}
                                <ProductPrice
                                    product={productContext}
                                    showLabel={false}
                                    showSavings={true}
                                    showSavingsAmount={productSettings.showSavingsAmount}
                                    showSavingsPercent={productSettings.showSavingsPercent}
                                    extendedStyles={styles.price}
                                    usePriceMinusCorePrice={true}
                                    showEcoLabel={true}
                                />
                            </>
                        )}
                    </GridItem>
                    <GridItem {...styles.productInfoGrid}>
                        <StyledWrapper {...styles.addToCartWrapper}>
                            <ProductQuantityOrdered label={null} extendedStyles={styles.quantityOrdered} />
                            <ProductAddToCartButton
                                labelOverride={translate("Add")}
                                data-test-selector={`actionsAddToCart${productContext.product.id}`}
                                extendedStyles={styles.addToCartButton}
                                analyticsId={analyticsListName}
                            />
                            {/* Store Custom Code */}
                            <OutOfMarketNoticeMailComponent
                                showLabel={false}
                                useToasts={true}
                                extendedStyles={actionsStyles.marketWarningStyles}
                            />
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            )}
            {/* Store Custom Code: Remove ProductUnitOfMeasureSelect */}
            {/* Store Custom Code: Remove StyledWrapper  */}
            {/* Store Custom Code: Remove showAddToList  */}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
